import {isEqualReadPecResp, ReadPecResp} from '../models';

export function remoteTemplateParser(original: ReadPecResp): [boolean, ReadPecResp] {
  const envelopeComment = new RegExp('<!--\\s?replace:envelope-btn\\s?-->', 'gm');
  const replacedEnvelope = replace(original, envelopeComment, '<app-envelope-button></app-envelope-button>');
  return [isEqualReadPecResp(original, replacedEnvelope), replacedEnvelope];
}

function replace(d1: ReadPecResp, arg1: RegExp, arg2: string): any {
  const copy = JSON.parse(JSON.stringify(d1)) as ReadPecResp;
  copy.data.body = d1.data.body.replace(new RegExp(arg1, 'gm'), arg2);
  return copy;
}
